// extracted by mini-css-extract-plugin
export default {"overlay":"bGeY","overlay-visible":"kGWw","overlayVisible":"kGWw","overlay-wrapper":"IcK8","overlayWrapper":"IcK8","overlay-spinner":"CFlg","overlaySpinner":"CFlg"};